import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/Layout'
import Login from '@/components/Login'

const index = () => import('@/views/index')
const about = () => import('@/views/about')
const robot = () => import('@/views/robot')
const embodiedCleaningRobot = () => import('@/views/EmbodiedCleaningRobot')
const facadeCleaningRobot = () => import('@/views/FacadeCleaningRobot')
const buyGuide = () => import('@/views/buyGuide')
const afterSale = () => import('@/views/afterSale')
const operMarket = () => import('@/views/operMarket')
const operProduct = () => import('@/views/operProduct')
const taipuFuture = () => import('@/views/taipuFuture')
const club = () => import('@/views/club')
const cityPartners = () => import('@/views/cityPartners')
const login = () => import('@/views/login')
const userInfo = () => import('@/views/userInfo')
const newsDetail = () => import('@/views/newsDetail')
const qrcode = () => import('@/views/qrcode')
const useGuide = () => import('@/views/h5/useGuide')
const productIntro = () => import('@/views/h5/productIntro')
const emergency = () => import('@/views/h5/emergency')
const aboutUs = () => import('@/views/h5/aboutUs')
const agreementPay = () => import('@/views/h5/agreementPay')
const agreementService = () => import('@/views/h5/agreementService')
const lianlianBankPay = () => import('@/views/h5/lianlianBankPay')  // 连连银行卡支付中间页面
const lianlianBankPayiframe = () => import('@/views/h5/lianlianBankPayiframe')  // 连连银行卡iframe支付中间页面
const identityCard = () => import('@/views/h5/identityCard')  // 身份证输入
const toYyxMini = () => import('@/views/h5/toYyxMini')  // 跳转悦悦喜


Vue.use(Router)

export default new Router({

    mode: 'history',
    routes: [
        {
            path: '/',
            name: '产品介绍',
            component: Layout,
            leaf: true,
            children: [
                { path: '/', alias:'/robot', component: index, name: '产品介绍'},
                { path: '/robot/b', component: robot, name: 'B系列-大巴车',  props: route => ({ index: route.query.index }), navs: [
                    '2刷龙门式', '3刷通道式', '3刷龙门式', '4刷通道式', '4刷龙门式', '5刷通道式', '5刷龙门式', '6刷通道式', '7刷通道式', '8刷通道式'
                ] },
                { path: '/robot/c', component: robot, name: 'C系列-乘用车', props: route => ({ index: route.query.index }), navs: [
                    'C-C505', 'C-C206', 'C-X701', 'C-Q系列', 'C-Z201（自助）', 'C-W001/F', 'C-M801'
                ]},
                { path: '/robot/d', component: robot, name: 'D系列-高铁动车', props: route => ({ viewType: 1 })},
                { path: '/robot/g', component: robot, name: 'G系列-工程车',  props: route => ({ index: route.query.index }), navs: [
                    'A矿山通过式', 'B码头通过式', 'C商砼龙门式', 'D钢厂龙门式', 'E工地专用滚轴式洗轮机', 'E平板型洗轮机',
                    'E滚轴式洗轮机 (出口型号)'
                ]},
                { path: '/robot/embodied-cleaning', component: embodiedCleaningRobot, name: '室内具身智能清洁机器人' },
                { path: '/robot/facade-cleaning', component: facadeCleaningRobot, name: '室外高空幕墙清洗机器人' },
                // { path: '/robot/w1', component: robot, name: '无人机产品系列1', props: route => ({ index: route.query.index }), navs: [
                //     '入云龙II', '入云龙II-P', '小旋风2', '小旋风S', '插翅虎M9', '插翅虎M10',
                //     '插翅虎M11'
                // ]},
                // { path: '/robot/w2', component: robot, name: '无人机产品系列2', props: route => ({ index: route.query.index }), navs: [
                //     '守护者X40', '守护者X60', '守护者X60Pro', '探索者E16', '探索者E600L', '舞空系列', '远行者T32', '闪速侠F210-T', '闪速侠·Aurora980'
                // ] },
                // { path: '/robot/x', component: robot, name: 'X系列' },
                // { path: '/robot/q', component: robot, name: 'Q系列' },
                // { path: '/robot/m', component: robot, name: 'M系列' },
                // { path: '/robot/zl9', component: robot, name: 'ZL9系列' },
            ]
        },
        {
            path: '/buyGuide',
            name: '选购指南',
            component: Layout,
            leaf: true,
            children: [
                { path: '/buyGuide', component: buyGuide, name: '选购指南'},
            ]
        },

        {
            path: '/operMarket',
            name: '运营支持',
            component: Layout,
            leaf: true,
            children: [
                { path: '/operMarket', component: operMarket, name: '运营支持'},
            ]
        },
        {
            path: '/afterSale',
            name: '售后支持',
            component: Layout,
            leaf: true,
            children: [
                { path: '/afterSale', component: afterSale, name: '售后支持' },
            ]
        },

        {
            path: '/about',
            name: '走进太仆',
            component: Layout,
            leaf: true,
            children: [
                { path: '/about', component: about, name: '走进太仆' }
            ]
        },

        // {
        //     path: '/taipuFuture',
        //     name: '太仆未来',
        //     component: Layout,
        //     leaf: true,
        //     children: [
        //         { path: '/taipuFuture', component: taipuFuture, name: '太仆未来' }
        //     ]
        // },

        // {
        //     path: '/club',
        //     name: 'CLUB',
        //     component: Layout,
        //     leaf: true,
        //     children: [
        //         { path: '/club', component: club, name: 'CLUB' }
        //     ]
        // },

        {
            path: '/cityPartners',
            name: '城市合伙人',
            component: Layout,
            leaf: true,
            children: [
                { path: '/cityPartners', component: cityPartners, name: '城市合伙人' }
            ]
        },
        // {
        //     path: '/cityPartners',
        //     name: '城市拍档',
        //     component: Layout,
        //     leaf: true,
        //     children: [
        //         { path: '/cityPartners', component: cityPartners, name: '城市拍档' }
        //     ]
        // },
        {
            path: '/newsDetail',
            name: '',
            hidden: true,
            component: Layout,
            leaf: true,
            children: [
                { path: '/newsDetail/:id', component: newsDetail, hidden: true, name: '新闻内容' }
            ]
        },
        {
            path: '/userInfo',
            component: Layout,
            beforeEnter: (to, from, next) => {
                if (sessionStorage.getItem('userId')) {
                    next()
                } else {
                    next({ path: '/login' })
                }
            },
            leaf: true,
            hidden: true,
            children: [
                { path: '/userInfo/', component: userInfo, name: '我的' },
            ]
        },
        {
            path: '/qrcode',
            component: qrcode,
            leaf: true,
            hidden: true,
            children: [
                { path: '/qrcode/:type/:id/:partner', component: qrcode, name: '二维码', hidden: true },
                { path: '/qrcode/:type/:id', component: qrcode, name: '二维码', hidden: true }
            ]
        },
        {
            path: '/h5/useGuide',
            component: useGuide,
            hidden: true,
        },
        {
            path: '/h5/productIntro',
            component: productIntro,
            hidden: true,
        },
        {
            path: '/h5/emergency',
            component: emergency,
            hidden: true,
        },
        {
            path: '/h5/aboutUs',
            component: aboutUs,
            hidden: true,
        },
        {
            path: '/h5/agreementPay',
            component: agreementPay,
            hidden: true,
        },
        {
            path: '/h5/agreementService',
            component: agreementService,
            hidden: true,
        },
        {
            path: '/h5/lianlianBankPay/:link',
            component: lianlianBankPay,
            hidden: true,
        },
        {
            path: '/h5/lianlianBankPayiframe/:link',
            component: lianlianBankPayiframe,
            hidden: true,
        },
        {
            path: '/h5/toyyx/',
            component: toYyxMini,
            hidden: true,
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        if(to.hash == '#contact-us') {
            setTimeout(function() {
                window.scroll({
                    top: 3800,
                    behavior: 'smooth'
                });
            }, 300)
            return
        }
        if (savedPosition) return savedPosition
        return { x: 0, y: 0 }
      }
})
